import { render, staticRenderFns } from "./offerWallIcon.vue?vue&type=template&id=bf06a16e&"
import script from "./offerWallIcon.vue?vue&type=script&lang=js&"
export * from "./offerWallIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports